import { usePageTitle } from '@app/hooks/usePageTitle';
import PoliciesWidget from '@widgets/settings/policies';

const SettingsPoliciesPage = () => {
  usePageTitle('Policies');

  return <PoliciesWidget />;
};

export default SettingsPoliciesPage;
